export const Buttons = {
  primary: {
    background: '#F13C00',
    '&:hover': {
      background: '#F13C00',
    },
    '&.Mui-disabled': {
      background: '#BBBBC4',
    },
  },
  primaryOutlined: {
    borderColor: '#F13C00',
    color: '#F13C00',
    '&:hover': {
      borderColor: '#F13C00',
    },
    '&.Mui-disabled': {
      borderColor: '#BBBBC4',
      color: '#BBBBC4',
    },
  },
};
